// const titalise = string => string.toLowerCase()
//     .split(' ')
//     .map(s => s.charAt(0).toUpperCase() + s.substring(1))
//     .join(' ');

const titalise = (string) => {
    if (!string || typeof string !== 'string') return '';
    return string.trimStart().replace(/[-_]/g, ' ').toLowerCase().replace(/(^\w|\s\w)/g, (c) => c.toUpperCase());
};

export default titalise;
